import { Drawer } from 'antd';
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
import { useCallback,useState } from 'react';


const AssetFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty

}) => {
  const [placement] = useState('right');  
  

   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Filters"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        footer={
          <div>
            {filters.some(filter => filter.value && filter.key !== "search") && (
              <Button
                label="Clear All"
                onClick={handleClearAll}
                className="btn btn-link w-100 mb-2 p-0"
                style={{ color: "var(--brand-text-muted)", fontWeight: 600 }}
              />
            )}
            <Button label="Apply Filter" loading={filterLoading} disabled={filterLoading || !isFilterDirty} onClick={handleApplyFilter} className="btn btn-primary w-100" style={{ borderRadius: "8px" }} />
          </div>
        }
      >
        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("issued_date_before")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "issued_date_before")}} 
          id="search" 
          label={"Issued Before"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("issued_date_after")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "issued_date_after")}} 
          id="search" 
          label={"Issued After"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("returned_date_before")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "returned_date_before")}} 
          id="search" 
          label={"Returned Before"} 
          />
        </div>

        
        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("returned_date_after")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "returned_date_after")}} 
          id="search" 
          label={"Returned After"} 
          />
        </div>


      </Drawer>
    </>
  );
};
export default AssetFilterDrawer;